var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popWrap"
  }, [_c('h2', [_vm._v("형제노드 추가")]), _c('div', {
    staticClass: "cont"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.inputText,
      expression: "inputText"
    }],
    ref: "inputWrite",
    attrs: {
      "type": "text",
      "placeholder": "형제노드명을 입력하세요."
    },
    domProps: {
      "value": _vm.inputText
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.inputText = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "btns"
  }, [_c('btn-link', {
    style: {
      minWidth: '60px'
    },
    on: {
      "click": _vm.clickCloseHandler
    }
  }, [_vm._v("취소")]), _c('btn-link', {
    style: {
      minWidth: '80px'
    },
    attrs: {
      "color": "blue"
    },
    on: {
      "click": _vm.updateHandler
    }
  }, [_vm._v("추가하기")])], 1), _c('CloseBtn', {
    attrs: {
      "closeHandler": _vm.clickCloseHandler
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }